import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IAuthorizationsConsultationFormMeta {
  receivingBank: FormInputMeta,
  sendingBank: FormInputMeta,
  authorizationNumber: FormInputMeta,
  sellerNumber: FormInputMeta,
  cardNumber: FormInputMeta,
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  noNameSelect: FormInputMeta,
  noNameTextInput: FormInputMeta,
  // Schema
  schema: any,
}

const AuthorizationsConsultationFormMeta = {} as IAuthorizationsConsultationFormMeta;

AuthorizationsConsultationFormMeta.receivingBank = {
  name: "receivingBank",
  label: "Banque Acquéreur",  
  type: 'select',
  options: [
    {
      label: 'bank One',
      value: 'bank1',
      selected: true,
    },
    {
      label: 'bank two',
      value: 'bank2',
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};
AuthorizationsConsultationFormMeta.sendingBank = {
  name: "sendingBank",
  label: "Banque Emettrice",  
  type: 'select',
  options: [
    {
      label: 'bank One',
      value: 'bank1',
      selected: true,
    },
    {
      label: 'bank two',
      value: 'bank2',
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};

AuthorizationsConsultationFormMeta.authorizationNumber = {
  name: 'authorizationNumber',
  type: 'text',
  label: 'Numero d\'autorisation',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

AuthorizationsConsultationFormMeta.sellerNumber = {
  name: 'sellerNumber',
  type: 'select',
  label: 'Numero Commerçant',
  options:  [
    {
      label: 'Numero Commerçant A',
      value: 'a'
    },
    {
      label: 'Numero Commerçant B',
      value: 'b',
    },
    {
      label: 'Numero Commerçant C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};

AuthorizationsConsultationFormMeta.cardNumber = {
  name: 'cardNumber',
  type: 'text',
  label: 'Numero Carte',
  placeholder: '',
  validation: yup.string().required(),
};
AuthorizationsConsultationFormMeta.startDate = {
  name: "startDate",
  type: "date",
  label: "Date debut",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

AuthorizationsConsultationFormMeta.endDate = {
  name: "endDate",
  type: "date",
  label: "Date fin",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
AuthorizationsConsultationFormMeta.noNameSelect = {
  name: "noNameSelect",
  label: "",  
  type: 'select',
  options: [
    {
      label: 'item One',
      value: 'item1',
      selected: true,
    },
    {
      label: 'item two',
      value: 'item2',
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};
AuthorizationsConsultationFormMeta.noNameTextInput = {
  name: 'noNameTextInput',
  type: 'text',
  label: '',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};



AuthorizationsConsultationFormMeta.schema = yup.object().shape(getValidationSchema(AuthorizationsConsultationFormMeta));

export default AuthorizationsConsultationFormMeta;